import React from "react";

interface RoomCellProps {
  roomNumber: number;
  roomCategoryName: string;
}

export const RoomCell: React.FC<RoomCellProps> = ({
  roomNumber,
  roomCategoryName,
}) => {
  return (
    <div className="flex flex-col">
      <span>{roomNumber}</span>
      <span>{roomCategoryName}</span>
    </div>
  );
};
